























































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { HistoricalDataStatsExcel, HistoricalDataVehicleStats, HistoricalParams, isParamInfoValid, Statistic, StatisticForExcel } from '../models';
import { hasElements } from '../utils';
import ChartLayout from './ChartLayout.vue';
import { TrackingService } from '../api';
import Axios from 'axios';
import { NotificationStoreHelper, RootStoreHelper } from '../mixins';
import { Destroyed, Mounted } from '../decorators';
import ExportExcelButton from './ExportExcelButton.vue';

@Component({
    components: { 
        ChartLayout,
        ExportExcelButton 
    }
})
export default class StatsInfo extends Mixins(NotificationStoreHelper, RootStoreHelper) {
    @Prop() paramsInfo: HistoricalParams;
    @Prop() selectedParamsInfo: HistoricalParams;
    @Prop({default: false}) expandedStats: boolean;
    totalStatistics: Statistic[] = [];
    selectedStatistics: Statistic[] = [];
    cancelTotalToken: any = null;
    cancelSelectedToken: any = null;
    pendingTotalRequest: boolean = false;
    pendingSelectedRequest: boolean = false;
    statsToExport: HistoricalDataStatsExcel = {
        recorrido_total: [],
        recorrido_seleccionado: []
    };
    excelColumns: Array<object> = [
        {
            text: 'Variable',
            align: '',
            value: 'variable'
        },
        {
            text: 'Valor',
            align: '',
            value: 'valor'
        }
    ]

    @Watch('paramsInfo')
    observerParamsInfo() {
        this.loadStats();
    }

    @Watch('selectedParamsInfo')
    observerSelectedParamsInfo() {
        this.loadSelectedStats();
    }

    @Mounted
    loadStats(): void {
        this.totalStatistics = [];
        this.statsToExport.recorrido_total = [];

        this.pendingTotalRequest = true;
        this.cancelTotalToken = Axios.CancelToken.source();
        if (isParamInfoValid(this.paramsInfo)) {
            TrackingService.getHistoricalDataByVehiclesStats(this.paramsInfo, this.cancelTotalToken, this.$_isMock)
                .then((result: HistoricalDataVehicleStats) => {
                    this.totalStatistics = result.statistics;
                    this.statsToExport.recorrido_total = this.parseStatisticsForExcel(this.totalStatistics);
                    this.pendingTotalRequest = false;
                    this.loadSelectedStats();
                })
                .catch(error => {
                    if (!Axios.isCancel(error)) {
                        this.pendingTotalRequest = false;
                        this.$_showStaticsError(error.message);
                    }
                });
        } else {
            this.totalStatistics = [];
            this.pendingTotalRequest = false;
        }
    }

    loadSelectedStats(): void {
        this.selectedStatistics = [];
        this.statsToExport.recorrido_seleccionado = [];
        if (this.selectedParamsInfo) {
            this.pendingSelectedRequest = true;
            this.cancelSelectedToken = Axios.CancelToken.source();
            if (isParamInfoValid(this.selectedParamsInfo)) {
                TrackingService.getHistoricalDataByVehiclesStats(
                    this.selectedParamsInfo,
                    this.cancelSelectedToken,
                    this.$_isMock
                )
                    .then((result: HistoricalDataVehicleStats) => {
                        this.selectedStatistics = result.statistics;
                        this.statsToExport.recorrido_seleccionado = this.parseStatisticsForExcel(this.selectedStatistics);
                        this.pendingSelectedRequest = false;
                    })
                    .catch(error => {
                        if (!Axios.isCancel(error)) {
                            this.pendingSelectedRequest = false;
                            this.$_showStaticsError(error.message);
                        }
                    });
            } else {
                this.selectedStatistics = [];
                this.pendingSelectedRequest = false;
            }
        }
    }

    parseStatisticsForExcel(stats: Statistic[]):StatisticForExcel[]{
        return stats.map(function(stat) { 
            return {
                variable: stat.description,
                valor: stat.value
            }
        })
    }

    get checkStatstHasElements(): boolean {
        return hasElements(this.totalStatistics);
    }

    get checkSelectedStatsHasElements(): boolean {
        return hasElements(this.selectedStatistics);
    }

    @Destroyed
    clean() {
        if (this.cancelTotalToken) {
            this.cancelTotalToken.cancel();
            this.cancelTotalToken = null;
        }
        if (this.cancelSelectedToken) {
            this.cancelSelectedToken.cancel();
            this.cancelSelectedToken = null;
        }
        this.pendingTotalRequest = false;
        this.pendingSelectedRequest = false;
        this.totalStatistics = [];
        this.selectedStatistics = [];
    }
}
